'use client';

import UserCircleIconSvg from '@/assets/svgs/main/canvassers-filled.svg';
import RequestCanvassersForm from '@/containers/Jobs/components/canvassers/RequestCanvassersForm/RequestCanvassersForm';
import { CanvasserScheduleFormData } from '@/containers/Jobs/components/canvassers/types';
import { Modals } from '@/containers/Modals/all-modals';
import ModalBody from '@/containers/Modals/ModalBody';
import ModalContainer from '@/containers/Modals/ModalContainer';
import ModalHeader from '@/containers/Modals/ModalHeader';
import useModals from '@/containers/Modals/useModals';
import classNames from 'classnames';
import { useRef } from 'react';
import { ModalProps, RequestCanvassersModalParams } from '../types';

interface RequestCanvassersModalProps extends ModalProps {
  params?: RequestCanvassersModalParams;
}

const modalName = Modals.RequestCanvassersModal;

const RequestCanvassersModal = ({
  className,
  variant = 'narrow',
  params,
}: RequestCanvassersModalProps) => {
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const { isModalOpen, onClose } = useModals({
    modalName,
  });

  // Extract jobId from params
  const jobId = params?.jobId || '';

  const handleSubmit = (data: CanvasserScheduleFormData) => {
    // TODO: Implement API call to submit canvasser request
    console.log('Submitting canvasser request:', data);
    // This will be implemented in the API integration phase
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className={classNames('relative', className)}>
      <input
        type="checkbox"
        id={modalName}
        className="modal-toggle"
        checked={isModalOpen}
        onChange={() => {}}
      />

      <ModalContainer
        isModalOpen={isModalOpen}
        modalName={modalName}
        variant={variant}
        onClose={onClose}>
        <div className="flex h-full flex-col">
          {/* Stick to top */}
          <ModalHeader
            modalName={modalName}
            icon={<UserCircleIconSvg className="h-5 w-5" />}
            title="Schedule Initial Canvassers"
          />

          {/* Take up remaining space and enable inside-scrolling */}
          <ModalBody ref={modalBodyRef} className="p-6">
            <RequestCanvassersForm
              jobId={jobId}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
            />
          </ModalBody>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button onClick={onClose}>close</button>
        </form>
      </ModalContainer>
    </div>
  );
};

export default RequestCanvassersModal;
